import { render, staticRenderFns } from "./CriarPedidoDeCompraView.vue?vue&type=template&id=6d40678e&scoped=true"
import script from "./CriarPedidoDeCompraView.vue?vue&type=script&setup=true&lang=js"
export * from "./CriarPedidoDeCompraView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CriarPedidoDeCompraView.vue?vue&type=style&index=0&id=6d40678e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d40678e",
  null
  
)

export default component.exports